import { ROOT_FLAG } from "@/store/mutations";

export default {
	namespaced: true,
	actions: {
		complete({ dispatch, rootState }) {
			dispatch("game/balance/withdraw", { amount: rootState.game.bummers.active.amount }, ROOT_FLAG);
		},
	},
};
